import {useTranslation} from "@Translation/hooks/useTranslation";
import {multiModalTranslationKey} from "@SearchResults/features/staticContent/constants/translationKeys";
import TitleAndContent from "@SearchResults/features/staticContent/components/TitleAndContent";
import {TransportTypesType} from "@SearchResults/types/TransportTypes.type";
import getTranslationFromTransportType
    from "@SearchResults/features/staticContent/functions/getTranslationFromTransportType";
import getTravelTimes from "@SearchResults/features/staticContent/functions/getTravelTimes";
import {RoutesOrganizedByTransportTypeType} from "@SearchResults/types/RoutesOrganizedByTransportType.type";

interface HowLongContentProps {
    departure: string,
    destination: string,
    singleRoutes: RoutesOrganizedByTransportTypeType,
    fastestVehClass: TransportTypesType,
    slowestVehClass: TransportTypesType,
}

function HowLongContent(props: HowLongContentProps) {
    const {
        departure,
        destination,
        singleRoutes,
        fastestVehClass,
        slowestVehClass,
    } = props

    const fastestVehClassTranslation = getTranslationFromTransportType(fastestVehClass)
    const slowestVehClassTranslation = getTranslationFromTransportType(slowestVehClass)
    const {minTime: durationMin} = getTravelTimes(singleRoutes[fastestVehClass])
    const {maxTime: durationMax} = getTravelTimes(singleRoutes[slowestVehClass])

    const title = useTranslation(
        `${multiModalTranslationKey}.how_long.title`,
        {departure, destination}
    )

    const description1 = useTranslation(
        `${multiModalTranslationKey}.how_long.desc1`,
        {
            departure,
            destination,
            fastestVehClass: fastestVehClassTranslation,
            durationMin,
            durationMin2: durationMin,
            durationMax2: durationMax,
            slowestVehClass: slowestVehClassTranslation,
            durationMax,
        }
    )

    return (
        <TitleAndContent
            title={title}
            content={description1}
        />
    )
}

export default HowLongContent